module.exports = __webpack_public_path__ + "static/media/8.662eb09a.jpeg";